exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-06bacded] .basic-block{width:100%;max-width:580px;margin:0 auto;position:relative;z-index:1}[data-v-06bacded] .basic-block .content-wrap{width:100%;position:relative;z-index:100}.lp-base--3[data-v-06bacded] .lp-footer{background:#9c8961}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06bacded","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/recommend/lp/RecommendBasicResultManager.vue
// module id = H1zt
// module chunks = 0